import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios, { AxiosError, AxiosRequestConfig } from "axios";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";

export const httpService =
  ({
    baseUrl = "",
  }): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params }) => {
    if (
      !window.reactApp.authToken &&
      url === "/user/info/exercise-entrypoint/0/"
    ) {
      return { error: { status: 401, data: "User not authorized" } };
    }
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: window.reactApp.authToken
          ? { Authorization: `Bearer ${window.reactApp.authToken}` }
          : {},
      });

      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      if (
        (err.response?.data as { message: string })?.message ===
        "Exercise user blocked"
      ) {
        const userId = window.apiUserId;
        const url = formatUrlWithLocale(`/u${userId}/unlimited-typing/`);
        window.location.href = url;
      }

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
